export const GRID_ITEM_SUB_LABEL = 'grid-item-sub-label';
export const OPEN_GRID_BUTTON = 'open-grid-button';
export const ITEM_SEARCH_AUTOCOMPLETE = 'item-search-autocomplete';
export const ITEM_SEARCH_AUTOCOMPLETE_OPTION =
  'item-search-autocomplete-option';
export const GRID_ITEM = 'grid-item';
export const GRID_ITEM_LABEL = 'grid-item-label';
export const GRID_BREADCRUMB = 'grid-breadcrumb';
export const GRID_BREADCRUMB_ITEM = 'grid-breadcrumb-item';
export const GRID_CANCEL_BUTTON = 'grid-cancel-button';
